export default __webpack_public_path__ + "static/media/dolphin_surface_full.abcf53d1.svg";